var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
var FooterPartner = function (props) {
    var partnerList = props.partnerList, children = props.children, className = props.className, 
    // @ts-ignore
    __TYPE = props.__TYPE, remainingProps = __rest(props, ["partnerList", "children", "className", "__TYPE"]);
    var main_partner;
    var additional_partner;
    var displayPartners = function () {
        for (var key in partnerList) {
            if (partnerList.hasOwnProperty(key)) {
                if (key === "mainPartner") {
                    var main_values = partnerList[key];
                }
                else {
                    var additional_values = partnerList[key];
                }
            }
            main_partner = main_values;
            additional_partner = additional_values;
        }
    };
    displayPartners();
    var displayPartner = function (partner) {
        return partner.map(function (p) {
            return (React.createElement("li", { key: p.id },
                React.createElement("a", { className: "footer__partners-link", href: p.link },
                    React.createElement("img", { className: "fr-footer__logo", src: p.image, alt: p.alt, style: { maxWidth: p.maxWidth } }))));
        });
    };
    return (React.createElement("div", __assign({}, remainingProps, { className: "fr-footer__partners" }),
        React.createElement("h4", { className: "fr-footer__partners-title" }, children),
        React.createElement("div", { className: "fr-footer__partners-logos" },
            React.createElement("div", { className: "fr-footer__partners-main" },
                React.createElement("ul", null, displayPartner(main_partner))),
            React.createElement("div", { className: "fr-footer__partners-sub" },
                React.createElement("ul", null, displayPartner(additional_partner))))));
};
FooterPartner.defaultProps = { __TYPE: "FooterPartner" };
FooterPartner.propTypes = { __TYPE: PropTypes.string };
export default FooterPartner;
